module.exports = __webpack_public_path__ + "098f8f1f01085ea062174c0dbd0092fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/jingcai.jpg
// module id = 1132
// module chunks = 0